import { render, staticRenderFns } from "./CustomizationBoxDecoration.vue?vue&type=template&id=5d5b42e6&"
import script from "./CustomizationBoxDecoration.vue?vue&type=script&lang=js&"
export * from "./CustomizationBoxDecoration.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationBoxDecoration.vue?vue&type=style&index=0&id=5d5b42e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports